/**
 * ALTO Region Modal — auto-open on first visit.
 *
 * Opens the region/language modal once per session until the visitor engages
 * with it, after which it never auto-opens again on this device. "Engages"
 * means either submitting the form OR closing the modal (X, Escape, backdrop) —
 * both count as an answer.
 *
 * Persistence of the actual region/language is handled server-side by Shopify
 * (the {% form 'localization' %} POST). This script only controls the trigger;
 * closing the modal does NOT submit anything (Shopify's detected region is
 * already active).
 */
(function () {
  var PERMANENT_KEY = 'alto-region-chosen';
  var SESSION_KEY = 'alto-region-prompted';

  // Safe storage helpers — fail silent so blocked storage never breaks the page
  // and never causes a per-load nag loop.
  function getFlag(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return 'blocked'; // treat unavailable storage as "already chosen" -> do not auto-open
    }
  }

  function setFlag(storage, key) {
    try {
      storage.setItem(key, '1');
    } catch (e) {
      /* ignore */
    }
  }

  // Mark permanent choice when a region-modal localization form is submitted.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.matches('form') && form.closest('[data-alto-region-modal]')) {
        setFlag(window.localStorage, PERMANENT_KEY);
      }
    },
    true
  );

  // Nothing more to do once the visitor has engaged with region selection.
  if (getFlag(window.localStorage, PERMANENT_KEY)) return; // chosen (or storage blocked)

  var dialog = document.querySelector('modal-dialog[data-alto-region-modal]');
  if (!dialog) return; // selectors disabled — nothing to open

  customElements.whenDefined('modal-dialog').then(function () {
    // Any close of the modal — X, Escape, or backdrop, whether it was
    // auto-opened or opened manually via the trigger — counts as a choice and
    // permanently silences the auto-open. Closing does NOT submit the form:
    // Shopify's detected region is already active server-side. (Form submit is
    // handled by the capture-phase listener above; a submit navigates away
    // rather than toggling [open], so it never reaches this observer.)
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'open' && !dialog.hasAttribute('open')) {
          setFlag(window.localStorage, PERMANENT_KEY);
          observer.disconnect();
          return;
        }
      }
    });
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    // Auto-open once per session until the visitor engages.
    if (getFlag(window.sessionStorage, SESSION_KEY)) return; // already prompted this session
    setFlag(window.sessionStorage, SESSION_KEY);

    var opener = document.querySelector('modal-opener[data-modal="#' + dialog.id + '"]');
    if (typeof dialog.show === 'function') {
      dialog.show(opener || undefined);
    }
  });
})();
